import {
  Box,
  Stack,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { clickToLinkHandler } from "../../../helpers/utils";

type Breadcrumb = {
  dataTestId?: string;
  title: string;
  path: string;
};

type DealPageTitleAndActionProps = {
  dataTestid?: string;
  title: string;
  subtitle?: string;
  breadcrumbs?: Breadcrumb[];
};

const DealPageTitleAndAction = ({
  title,
  subtitle,
  breadcrumbs,
}: DealPageTitleAndActionProps) => {
  const theme = useTheme();

  const breadcrumbText: SxProps<Theme> = {
    fontFamily: theme.typography.fontFamily,
    fontSize: "0.9rem",
    fontWeight: 500,
    textDecoration: "none",
    color: theme.palette.secondary.darker,
    cursor: "pointer",
  };

  return (
    <Box
      sx={{
        maxWidth: "900px",
      }}
    >
      <Stack flexDirection={"row"}>
        {breadcrumbs &&
          breadcrumbs.map((breadcrumb, index) => {
            return (
              <Stack key={index + breadcrumb.title} flexDirection={"row"}>
                {index > 0 && (
                  <Typography
                    sx={{
                      ...breadcrumbText,
                      color: theme.palette.tertiary.darker,
                    }}
                    paddingX={1}
                  >
                    /
                  </Typography>
                )}
                <Typography
                  data-testid={breadcrumb.dataTestId}
                  key={index}
                  sx={breadcrumbText}
                  onClick={() => {
                    clickToLinkHandler(breadcrumb.path);
                  }}
                >
                  {breadcrumb.title}
                </Typography>
              </Stack>
            );
          })}
      </Stack>
      <Typography variant="h1" mt={"0.3rem"} noWrap>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="subtitle1" mt={"0.1rem"}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default DealPageTitleAndAction;
